import { Interceptor } from "@core/api/interceptors/interceptor";
import { AxiosResponse } from "axios";

class FakeNetworkError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

const ERROR_THRESOLD = 0.33;

export const fakeBadNetworkInterceptor: () => Interceptor<AxiosResponse> = () => ({
	onFulfilled: response => {
		if (response.config.url?.includes("/pts/me")) return response;
		return Math.random() <= ERROR_THRESOLD ? Promise.reject(new FakeNetworkError("Random network error!!")) : response;
	},
	onRejected: error => Promise.reject(error),
});
